export const PROMPT_BOX_TAGS = ['tag_1', 'tag_2', 'tag_5', 'tag_4', 'tag_3', 'tag_6'] as const;
